// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__zIG18","deleteBtnColor":"style_deleteBtnColor__chz7d"};